import previewImg from './index.vue'

export default {
  install(Vue, options) {
    Vue.prototype.$previewImg = function(opt) {
      // 继承messageBox组件
      const PreviewImgConstructor = Vue.extend(previewImg)
      // 创建一个新元素
      const PreviewImgWrap = document.createElement('div')
      PreviewImgWrap.className = 'preview-Img-wrap'
      // 实例化messageBox组件，并将组件挂在到新创建的message-box-wrap元素上
      const PreviewImgInstace = new PreviewImgConstructor({
        el: PreviewImgWrap
      })
      // 或者使用 messageInstace.$mount(messageWrap)挂载
      document.body.appendChild(PreviewImgInstace.$el)
      // 显示组件内容
      if (opt) {
        PreviewImgInstace.data = opt.data
        PreviewImgInstace.title = opt.title
        PreviewImgInstace.download = opt.download
      }
      PreviewImgInstace.centerDialogVisible = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/libs/previewImg/index.js